import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  componentDestroyed,
  Game,
  GameUser,
  UntilDestroy
} from '@mtgame/core';
import { SeoService } from '@core/services/seo.service';
import { LeagueRootService } from '@core/services/league-root.service';
import { GameTimelineService } from '@core/services/game-timeline.service';
import { GameRootService } from '@core/services/game-root.service';

@UntilDestroy
@Component({
  selector: 'mtg-tournament-game-timeline',
  templateUrl: './tournament-game-timeline.component.html',
  styleUrls: ['./tournament-game-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentGameTimelineComponent implements OnInit, OnDestroy {
  game: Game;
  sort: 'asc' | 'desc' = 'desc';
  league = this.leagueRootService.getLeagueModel();

  constructor(
    private leagueRootService: LeagueRootService,
    private gameRootService: GameRootService,
    private gameTimelineService: GameTimelineService,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
  ) {
  }

  ngOnInit(): void {
    this.gameRootService.game$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(game => {
        this.game = game;
        if (game.isClosed) {
          this.sort = 'asc';
        }
        this.cdr.markForCheck();

        let title = '';
        let description = '';
        if (game.isClosed) {
          const winnerTeam = game.isTeamWon ? game.team : game.competitorTeam;
          const loserTeam = game.isTeamWon ? game.competitorTeam : game.team;
          if (game.team.sport.isHockey()) {
            description = `Победа ${winnerTeam.name} в игре против ${loserTeam.name}`;
          } else {
            description = `Победа ${winnerTeam.name} в матче против ${loserTeam.name}`;
          }
        }
        if (game.team.sport.isHockey()) {
          title = `Ход игры. Игра ${game.team.name} против ${game.competitorTeam.name}`;
        } else {
          title = `Ход игры. Матч ${game.team.name} против ${game.competitorTeam.name}`;
        }
        this.seoService.setData({
          title,
          description,
        });
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    this.gameTimelineService.dispose();
  }

  get logs$(): Observable<any[]> {
    return this.gameTimelineService.logs$;
  }

  get gameUsers$(): Observable<GameUser[]> {
    return this.gameTimelineService.users$;
  }
}
